var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"powered-by__logo"},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"powered_by_image",attrs:{"data-src":require("@/assets/img/footer/webuycar.svg"),"alt":"webuycar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }